import applicationError from './application-error.json'
import bankEmptyState from './bank-empty-state.json'
import billsEmptyState from './bills-empty-state.json'
import confetti from './confetti.json'
import contactsEmptyState from './contacts-empty-state.json'
import errorIcon from './error-icon.json'
import invoicesEmptyState from './invoices-empty-state.json'
import processing from './processing.json'
import productsEmptyState from './products-empty-state.json'
import quotesEmptyState from './quotes-empty-state.json'
import recurringInvoicesEmptyState from './recurring-invoices-empty-state.json'
import scoutConnectedProcessing from './scout-connected-processing.json'
import successIcon from './success-icon.json'

export default {
  applicationError,
  bankEmptyState,
  billsEmptyState,
  confetti,
  contactsEmptyState,
  errorIcon,
  invoicesEmptyState,
  processing,
  productsEmptyState,
  quotesEmptyState,
  recurringInvoicesEmptyState,
  scoutConnectedProcessing,
  // @todo: replace with the transactions animation
  transactionsEmptyState: invoicesEmptyState,
  successIcon,
}
